import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/models/errorObj.interface";
import { ArtifactsProps } from "../../../shared/interfaces/components/history-artifacts/historyArtifacts.interface";
import { recoverResponseData } from "../../../feature/historyArtifacts/pages/historyArtifacts";

export const getArtifacts = (
  payload: ArtifactsProps
): Promise<AxiosResponse> => {
  const uid = window.sessionStorage.getItem("uid") ?? payload.uid;
  const URL = `https://krakend-3ksvd3ddra-oa.a.run.app/nexbot/artifacts/${uid}`;

  return axios
    .get(URL)
    .then((res: AxiosResponse) => {
      recoverResponseData(res.data);
      return res.data;
    })
    .catch((e: ErroObj) => {
      console.log("error on nexbot/artifacts");
      /*ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );*/
    });
};
